import React, { PureComponent } from 'react'
import classnames from 'classnames'
import BaseIcon from './BaseIcon'

const SimpleIcon = props => {
  return <BaseIcon {...props} family="simpleicon" />
}

export default SimpleIcon
